// Controls
import { ScreenReaderOnly } from "@ms/planner-generic-controls/lib/local/screenReaderOnly/ScreenReaderOnly";
// Utilities
import { Button, Link, Spinner, Toast, ToastBody, ToastTitle, ToastTrigger } from "@fluentui/react-components";
import { Dismiss } from "@ms/planner-generic-controls/lib/local/icons";
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
import React from "react";
import { useToastContentStyles } from "./ToastContent.styles";
/** Presentational component for rendering toast content */ export function ToastContent({ toast, useInvertedAppearance = true }) {
    const styles = useToastContentStyles();
    // Create the action link if action exists
    const actionLink = toast.action ? /*#__PURE__*/ React.createElement(Link, {
        inline: true,
        onClick: toast.action.onClick
    }, toast.action.label) : undefined;
    // Wrap with ToastTrigger if dismissOnAction is true
    const toastAction = actionLink && toast.action?.dismissOnAction ? /*#__PURE__*/ React.createElement(ToastTrigger, null, actionLink) : actionLink;
    // Create the body content
    let bodyContent = toast.body?.content;
    if (toast.body?.onClick) {
        const linkStyle = toast.body.hideUnderline ? {
            textDecoration: "none"
        } : undefined;
        const bodyLink = /*#__PURE__*/ React.createElement(Link, {
            inline: true,
            onClick: toast.body.onClick,
            style: linkStyle
        }, toast.body.content);
        bodyContent = toast.body.dismissOnClick ? /*#__PURE__*/ React.createElement(ToastTrigger, null, bodyLink) : bodyLink;
    }
    const toastElement = /*#__PURE__*/ React.createElement(Toast, {
        appearance: useInvertedAppearance ? "inverted" : undefined
    }, /*#__PURE__*/ React.createElement(ToastTitle, {
        action: /*#__PURE__*/ React.createElement(ToastTrigger, null, /*#__PURE__*/ React.createElement(Button, {
            className: styles.dismissButton,
            appearance: "transparent",
            icon: /*#__PURE__*/ React.createElement(Dismiss, {
                fontSize: "20px",
                className: useInvertedAppearance ? styles.dismissIconInverted : styles.dismissIconDefault
            }),
            "aria-label": Strings.PlanHeader_MessageBar_DismissText_AriaLabel
        })),
        media: toast.intent === "progress" ? /*#__PURE__*/ React.createElement(Spinner, {
            size: "extra-tiny",
            style: {
                alignSelf: "flex-start"
            }
        }) : undefined
    }, toast.title), toast.body && /*#__PURE__*/ React.createElement(ToastBody, null, bodyContent), toastAction && /*#__PURE__*/ React.createElement(ToastBody, null, toastAction));
    return toast.isHidden ? /*#__PURE__*/ React.createElement(ScreenReaderOnly, null, toastElement) : toastElement;
}
